<template>
  <v-dialog v-model="opened" persistent max-width="310" light>
    <v-card>
      <v-card-title class="headline">
        Créer un répertoire
      </v-card-title>

      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="validForm" lazy-validation @submit.prevent="">
          <v-text-field
            ref="NewFolderFileNameField"
            v-model="folderName"
            label="Nom du répertoire *"
            required
            placeholder="Nom du répertoire"
            color="info"
            :rules="[rules.required, rules.noSlash]"
            autofocus
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="success" small @click="createFolder">
          Create
        </v-btn>

        <v-btn color="info" small @click="close">
          Annuler
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { useStore } from 'vue2-helpers/vuex';
import { useRouter } from 'vue2-helpers/vue-router';

import { getGraphqlSchema } from '../../graphql/index';
import { EventBus } from '../../mixins';

const store = useStore();

const router = useRouter();

const directory = ref(null);

const opened = ref(false);

const creating = ref(false);

const validForm = ref(false);

const folderName = ref('');

const form = ref(null);

const rules = reactive({
  required: v => !!v || 'Required',
  noSlash: v => (!v || !/\/|%2F/i.test(v)) || 'Le caractère "/" n\'est pas autorisé'
});

const open = newDirectory => {
  opened.value = true;
  // Opens dialog box

  // Clears the folder name input field
  folderName.value = '';

  // Set's the directory where the folder will be create
  directory.value = newDirectory;
};

// eslint-disable-next-line no-undef
defineExpose({ open });

const close = () => {
  if (opened.value) {
    opened.value = false;
  }
};

const { mutate: createDir, onDone, onError } = useMutation(getGraphqlSchema('createFolder'), () => ({
  variables: {
    path: directory.value,
    folderName: folderName.value,
    workspace: store.getters.workspace.code
  }
}));

onDone(result => {
  creating.value = false;

  const item = {
    uuid: result.data.createDir.uuid,
    name: result.data.createDir.name,
    wtitle: result.data.createDir.name,
    path: `${directory.value}`,
    // folder_name: `${folderName.value}`,
    wtype: 'folder'
  };

  // Emit event to add row from table
  EventBus.$emit('addItem', item);

  if (directory.value === '/') {
    router.push(`/folders/${folderName.value}`);
  } else {
    router.push(`/folders${directory.value}/${folderName.value}`);
  }

  const options = {
    closeable: true,
    timeout: 4000,
    type: 'success'
  };

  const text = `Folder "${folderName.value}" created!`;

  EventBus.$emit('show-notification', { text, options });
});

onError(error => {
  creating.value = false;

  const options = {
    closeable: true,
    timeout: 4000,
    type: 'error'
  };

  const text = error.message;

  EventBus.$emit('show-notification', { text, options });
});

const createFolder = () => {
  if (form.value.validate()) {
    creating.value = true;

    const options = {
      timeout: 5000,
      type: 'info'
    };

    const text = `Creating folder "${folderName.value}"`;
    EventBus.$emit('show-notification', { text, options });

    createDir();

    close();
  }
};

</script>

<style lang="scss">
.v-card__actions {
  height: 50px;
}
</style>
